module.exports = __webpack_public_path__ + "static/media/img_3-7b.3ed7312e.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/c-2/img_3-7b.png
// module id = 657
// module chunks = 0